import React from 'react';
import styled, { css } from 'styled-components';
import Color from 'color';

import Radio from 'antd/lib/radio';
import Field from 'hive-admin/src/components/Field';
import FieldSelect from 'hive-admin/src/components/FieldSelect';

import Admin from './Admin';

export const RadioGroup = styled(Radio.Group)`
  > label.ant-radio-button-wrapper-disabled {
    background-color: #d5d5d5;
    &:not(.ant-radio-button-wrapper-checked) {
      color: #c9c9c9;
      background-color: #fff;
    }
  }
  > label.ant-radio-button-wrapper-checked {
    &:not(.ant-radio-button-wrapper-disabled) {
      background: ${({ theme }) => Color(theme.less.primaryColor).fade(0.94)}
    }
  }
  > label.ant-radio-button-wrapper {
    .choice-label-component {
      transition: color 0.3s, background 0.3s, border-color 0.3s;
      height: 100%;
      width: 100%;
    }
    .choice-label-component[data-choice-label-mask-image-enabled="true"] {
      mask-size: contain;
      mask-repeat: no-repeat;
      mask-position: center;
      background: var(--text-color);
    }
    &:not(.ant-radio-button-wrapper-disabled):hover {
      .choice-label-component[data-choice-label-mask-image-enabled="true"] {
        background: var(--primary-color);
      }
    }
    &.ant-radio-button-wrapper-checked {
      .choice-label-component[data-choice-label-mask-image-enabled="true"] {
        background: var(--primary-color);
      }
    }
    &.ant-radio-button-wrapper-disabled:not(.ant-radio-button-wrapper-checked) {
      .choice-label-component[data-choice-label-mask-image-enabled="true"] {
        background: var(--disabled-color);
      }
    }
  }
  ${({ block }) => block && css`
    position: relative;
    width: 100%;
    display: none;
    display: flex;
    overflow: scroll;
    gap: 10px;

    & > label {
      flex: 1;
      flex-grow: 1;
      flex-shrink: 1;
      text-align: center;
      white-space: nowrap;
    }
  `}
`;

export default class FieldRadio extends FieldSelect {
  static config = {
    ...FieldSelect.config,
    Component: RadioGroup,
    choiceClass: Radio.Button,
    // eslint-disable-next-line no-unused-vars
    prepareValueForInput: (value, props) => value,
    // eslint-disable-next-line no-unused-vars
    prepareValueForForm: (value, props) => value,
    renderChoice: (choice, field, props) => (
      <props.choiceClass
        key={props.getChoiceValue(choice, field, props)}
        value={props.getChoiceValue(choice, field, props)}
        style={{
          ...(props.choiceStyle || {}),
          ...(choice.style || {}),
        }}
        onClick={(event) => {
          if (props.toggleable) {
            if (event.target.value === props.value) {
              field.handleChange({
                ...event,
                target: {
                  ...event.target,
                  value: undefined,
                },
              });
              event.stopPropagation();
            }
          }
          return undefined;
        }}
        {...(props.choiceExtraProps || {})}
        {...(choice.extraProps || {})}
      >
        {props.getChoiceLabel(choice, field, props)}
      </props.choiceClass>
    ),
  }

  static inputPropsMap = {
    ...Field.inputPropsMap,
    block: true,
    buttonStyle: true,
    defaultChecked: true,
    toggleable: true,
  }

  handleChange = (event) => {
    this.props.onChange({
      ...event,
      target: {
        ...event.target,
        value: this.props.prepareValueForForm(event.target.value, this.props),
      },
    });
  }

  renderInput(props) {
    return (
      <this.props.Component
        key={props.name}
        {...props}
        value={props.value}
        onChange={this.handleChange}
      >
        {this.props.renderChoices(this, this.getStatefullProps())}
      </this.props.Component>
    );
  }
}

Admin.addToLibrary(
  'FieldRadio',
  config => FieldRadio.create(config),
);
